import { useCallback, useMemo, useState } from "react";
import PortalPaymentsService from "../../../services/portalPayment";
import { transformToFloat } from "../../../lib/transformToFloat";
import { useTaskStatus } from "./useTaskStatus";

export const useCompleteThirdStep = (
  request: any,
  setStep: React.Dispatch<React.SetStateAction<number>>,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [error, setError] = useState<string | null>(null);

  const onSuccess = useCallback(() => {
    setIsLoading(false);

    setStep(4);
  }, [setStep]);

  const onError = useCallback((val: string) => {
    setError(val);

    setIsLoading(false);
  }, []);

  const requestData: any = useMemo(() => {
    const req: any = {
      amount: transformToFloat(request.amount),
      isCustomAmount: request.amountOption === 2,
      contractNumber: request.contractNumber,
      providerSpecific: {
        $type: request.providerName.toLowerCase(),
      },
    };

    if (request.comments) {
      req.comment = request.comments;
    }

    if (request.newMethod) {
      const phone = request.newMethod.billingPhone.replace(/[\s-()]/g, "");

      req.providerSpecific.tokenizerToken = request.newMethod.fluidToken;
      req.providerSpecific.savePaymentMethod = request.newMethod.saveForFuture;
      req.providerSpecific.billingFirstName =
        request.newMethod.billingFirstName;
      req.providerSpecific.billingLastName = request.newMethod.billingLastName;
      req.providerSpecific.billingEmail = request.newMethod.billingEmail;
      req.providerSpecific.billingAddress = request.newMethod.billingAddress;
      req.providerSpecific.billingCity = request.newMethod.billingCity;
      req.providerSpecific.billingState = request.newMethod.billingState;
      req.providerSpecific.billingZipCode = request.newMethod.billingZipCode;
      req.providerSpecific.billingPhone = phone;
    } else {
      req.providerSpecific.providerPaymentMethodId =
        request.selectedMethodInfo.id;
    }

    return req;
  }, [request]);

  const { getStatus } = useTaskStatus(onError, onSuccess);

  const onSubmit = useCallback(async () => {
    try {
      setError(null);
      setIsLoading(true);

      const taskId: string =
        await PortalPaymentsService.providerPayment(requestData);

      getStatus(taskId);
    } catch (e: any) {
      setError(e.response.data.title);
      setIsLoading(false);
    }
  }, [getStatus, requestData]);

  return { isLoading, onSubmit, error };
};
